import React from 'react';
import styled, { css, createGlobalStyle } from 'styled-components';
import { getContext, BORDER_BOX } from 'common';
import { SPACING_8, SPACING_48 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/spacing';

export const HIGHLIGHT_CLASSNAME = 'ccfk-find-and-filter-highlight';
export const SELECTED_HIGHLIGHT_CLASSNAME = 'ccfk-find-and-filter-highlight-selected';
export const FILTER_HIGHLIGHT_CLASSNAME = 'ccfk-filter-highlight';
const FilterFieldIcon = styled.div`
  position: absolute;
  height: ${SPACING_48};
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${props => props.variant === 'outlined' && css`
    left: ${SPACING_8};
  `};
  ${props => props.$rtl && css`
    left: initial;
    right: 0.375rem;
    ${props.variant === 'outlined' && css`
      right: ${SPACING_8};
    `};
  `};
  & svg * {
    fill: ${props => props.$theme.icon};
    margin: 0;
  }
`;

const FilterFieldClearButton = styled.div`
  position: absolute;
  right: 0;
  top: ${SPACING_8};
  left: initial;
  ${props => props.$rtl && css`
    left: 0;
    right: initial;
  `};
  & svg * {
    fill: ${props => props.$theme.icon};
    margin: 0;
  }
`;

const FilterField = styled.div`
  position: relative;
  height: ${SPACING_48};
  display: flex;
  ${props => props.$rtl && css`
    direction: rtl;
  `};
  input {
    background: transparent;
  }
  input::-ms-clear {
    display: none;
  }
`;

const FilterMatchesContainer = styled.div`
  ${BORDER_BOX}
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: ${SPACING_8};
  height: 1.25rem
`;

const ArrowButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 2.75rem;
`;

const MatchCountContainer = styled.div`
  ${BORDER_BOX}
  ${({ $theme, $rtl }) => css`
    color: ${$theme.content};
    direction: ${$rtl ? 'rtl' : 'ltr'};
  `}
  font-size: 0.875rem;
  padding: 0 ${SPACING_8}
`;

const SearchHighlightStyle = createGlobalStyle`
.${HIGHLIGHT_CLASSNAME} {
  ${({ $theme }) => css`background-color: ${$theme.match}`}
}
.${SELECTED_HIGHLIGHT_CLASSNAME} {
  ${({ $theme }) => css`background-color: ${$theme.matchSelected}`}
}
.${FILTER_HIGHLIGHT_CLASSNAME} {
  ${({ $theme }) => css`font-family: ${$theme.filterMatchedText}`}
}
`;

export const GlobalCCFKSearchHighlightStyle = () =>
  getContext(({ theme }) => <SearchHighlightStyle $theme={theme.FILTER_FIELD} />);

export default {
  FilterFieldIcon,
  FilterFieldClearButton,
  FilterField,
  FilterMatchesContainer,
  ArrowButtonsContainer,
  MatchCountContainer
};
